import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export const error = (props) => {
  return <ErrorOutlineIcon {...props} />;
};
